import styled from 'styled-components';
import colors from '@general/colors';

export const List = styled.ul`
    list-style: none;
    position: absolute;
    left: 0;
    top: 54px;
    z-index: 1;
    width: 100%;
    min-height: 86px;
    max-height: 390px;
    overflow: scroll;
    margin: 0;
    padding: 0;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    background-color: #ffffff;
    box-shadow: 0 0 16px 0 rgba(87, 87, 87, 0.2);
`;

export const ListItem = styled.li`
    min-height: ${props => (props.listItemMinHeight ? props.listItemMinHeight : 'auto')};
    padding: 10px 10px;
    cursor: pointer;
    display: flex;
    font-size: 16px;
    align-items: center;
    &.browsed-option,
    &:hover {
        background-color: #deebff;
    }
`;

export const ContainerStyled = styled.div`
    align-items: center;
    display: flex;
    position: relative;
    width: 100%;
`;

export const LeftIconWrapper = styled.div`
    align-items: center;
    display: flex;
    height: 20px;
    justify-content: center;
    left: 10px;
    position: absolute;
    top: 18px;
    width: 20px;
`;

export const RightIconWrapper = styled.div`
    align-items: center;
    display: flex;
    height: 20px;
    justify-content: center;
    position: absolute;
    right: 10px;
    top: 18px;
`;

export const InputContainerStyled = styled.div`
    width: 100%;
`;

export const CloseIconWrapperStyled = styled.div`
    margin-right: 15px;
`;

export const CaretIconWrapperStyled = styled.div`
    /*  */
`;

export const FixedFooterStyled = styled.div`
    align-items: center;
    border-top: 1px solid ${colors.lightGray};
    cursor: default;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 8px 18px;
`;

export const FooterTextStyled = styled.p`
    color: ${colors.mediumGray};
    font-family: Red Hat Display;
    font-size: 16px;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 0.31px;
    margin-bottom: 0;
    text-align: left;
`;

export const FooterLinkTextStyled = styled.span`
    color: ${colors.azure};
    font-family: Red Hat Display;
    font-size: 12px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0.94px;
    margin-bottom: 0;

    &:hover {
        cursor: pointer;
    }
`;
